<template>
  <div class="container-custom">
    <Breadscrumbs
      :links="[
        { name: 'Awards', to: { path: '/awards' } },
        { name: 'Create', to: { path: '/awards/create' } },
      ]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>新增Award Info</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">取消</button>
      <button class="btn btn-primary" @click="saveHandler">儲存</button>
    </div>
    <!-- Create Edit Award Info -->
    <AwardCreateEdit></AwardCreateEdit>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import AwardCreateEdit from '@/views/D_Awards/c/AwardCreateEdit.vue';

export default {
  components: {
    Breadscrumbs,
    AwardCreateEdit,
  },
  computed: {
    ...mapState('award', ['award']),
  },
  created() {
    this.setAward({});
  },
  methods: {
    ...mapActions('award', ['setAward', 'save']),
    cancelHandler() {
      this.$router.push('/awards');
    },
    saveHandler() {
      this.save(this.award).then(() => {
        this.$router.push({ name: 'AwardList' });
      });
    },
  },
};
</script>

<style></style>
